<div class="custom-move-overlay" (click)="close.emit()" (keydown.escape)="close.emit()" (keydown)="$event.stopPropagation()">
  <dialog class="custom-move-modal" open aria-labelledby="custom-move-title"
    aria-modal="true"
    (click)="$event.stopPropagation()" (keydown)="onDialogKeydown($event)">
    <header class="modal-header">
      <h2 id="custom-move-title">Custom Move</h2>
      <button type="button" class="modal-close" (click)="close.emit()" aria-label="Close">
        <lucide-angular name="x" [size]="16" aria-hidden="true"></lucide-angular>
      </button>
    </header>
    <div class="modal-body">
      <p id="move-help">Specify a row to move the selected values to</p>
      <label for="custom-move-input">Row Number</label>
      <input #moveInput id="custom-move-input" type="number" min="1" [max]="maxRows"
        [(ngModel)]="target" class="modal-input" aria-describedby="move-help"
        [attr.aria-invalid]="moveInput?.validity?.valid === false" />
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn-secondary" (click)="close.emit()">Cancel</button>
      <button type="button" class="btn-primary" (click)="submit()" [disabled]="!isValid">
        Move Row
      </button>
    </footer>
  </dialog>
</div>
